export const uniqueIdForSSOExternalId = 'sso_external_id';